import { render } from "./04_TribalBenefit.vue?vue&type=template&id=171f9544&scoped=true"
import script from "./04_TribalBenefit.vue?vue&type=script&lang=js"
export * from "./04_TribalBenefit.vue?vue&type=script&lang=js"

import "./04_TribalBenefit.vue?vue&type=style&index=0&id=171f9544&lang=css"
import "./04_TribalBenefit.vue?vue&type=style&index=1&id=171f9544&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171f9544"]])

export default __exports__